/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useState, useEffect} from "react";
import OurAdvisors from "./OurAdvisors";

const OurAdvisorsContainer = () => {
  const [settings, setSettings] = useState({
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
    swipeToSlide: true,
    centreMode: true,
    className: "slide-arrows"
  });
  const [showOverlay, setShowOverlay] = useState(false);
  const [activeVideo, setActiveVideo] = useState("");

  useEffect(() => {
    if (showOverlay) {
      document.body.classList.add("hide-scroll");
    } else {
      document.body.classList.remove("hide-scroll");
    }
  }, [showOverlay]);

  useEffect(() => {
    const windowWidth = window.innerWidth;

    const newSettings = {...settings};

    if (windowWidth < 1124) {
      newSettings.slidesToScroll = 2;
      newSettings.slidesToShow = 2;
      setSettings(newSettings);
    }
    if (windowWidth < 768) {
      newSettings.slidesToScroll = 1;
      newSettings.slidesToShow = 1;
      setSettings(newSettings);
    }
  }, []);

  return (
    <OurAdvisors
      activeVideo={activeVideo}
      setActiveVideo={setActiveVideo}
      setShowOverlay={setShowOverlay}
      settings={settings}
      showOverlay={showOverlay}
    />
  );
};

export default OurAdvisorsContainer;
